<!--
  Copyright (c) 2025-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
@if (permission()) {
<div class="container">
  <h2>Configurations</h2>

  @if (isLoading) {
    <div>Loading configurations...</div>
  }

  @if (!isLoading && configurations.length) {
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Name</th>
          <th>Value</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        @for (config of configurations; track config; let i = $index) {
          <tr>
            <td>{{ config.configKey }}</td>
            <td>
              <div class="value-container">
                @if (editingIndex !== i || config.description.toLowerCase().startsWith('file id')) {
                  <div class="value-display">
                    @if (isJson(config)) {
                      <!-- A JSON document stays one truncated line until asked for, then shows formatted. -->
                      @if (isJsonExpanded(config)) {
                        <pre class="json-full">{{ formatJson(config.value) }}</pre>
                      } @else {
                        <span class="json-preview">{{ config.value }}</span>
                      }
                      <button type="button" class="btn btn-link btn-sm json-toggle" (click)="toggleJson(config)">
                        {{ isJsonExpanded(config) ? 'Hide' : 'Show' }}
                      </button>
                    } @else {
                      {{ config.value }}
                    }
                    @if (config.fileName) {
                      <a (click)="getFile(config.value, config.fileName)">{{config.fileName}}</a>
                    }
                  </div>
                } @else if (isJson(config)) {
                  <label class="json-input-label" for="config-json-{{ i }}">Value of {{ config.configKey }}</label>
                  <textarea id="config-json-{{ i }}" [(ngModel)]="editValue" class="form-control value-input json-input"
                            rows="20" spellcheck="false" [attr.aria-label]="'Value of ' + config.configKey"></textarea>
                } @else {
                  <input [(ngModel)]="editValue" class="form-control value-input" placeholder="Enter new value"/>
                }
                @if (config.configKey !== 'version()') {
                  <div class="action-buttons">
                    @if (editingIndex !== i && !config.description.toLowerCase().startsWith('file id')) {
                      <button
                        class="btn btn-primary btn-sm" (click)="startEdit(i, config)">
                        Edit
                      </button>
                    }
                    @if (editingIndex !== i && config.description.toLowerCase().startsWith('file id')) {
                      <button
                        class="btn btn-primary btn-sm" (click)="startEdit(i, config); triggerFileInput(i)">
                        Upload
                      </button>
                    }
                    @if (editingIndex === i) {
                      <button class="btn btn-success btn-sm" (click)="saveEdit(config)">
                        Save
                      </button>
                    }
                    &nbsp;
                    @if (editingIndex === i) {
                      <button class="btn btn-secondary btn-sm" (click)="cancelEdit(config)">
                        Cancel
                      </button>
                    }
                    <input type="file" [id]="'fileInput-' + i" style="display: none;" (change)="onConfigFileSelected(i, config, $event)">
                  </div>
                }
              </div>
            </td>
            <td>{{ config.description }}</td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (!configurations.length && !isLoading) {
    <div>
      No configurations found.
    </div>
  }
</div>
}